$(document).on('turbo:load', function() {
  function validate_field(id, error_message_id, type = 'email') {
    const $fields = $(`.${id}`);
    const $errorMsg = $(`.${error_message_id}`);

    if (type === 'email') {
      function formatEmail() {
        const value = $(this).val();
        const emailRegex = /^[a-zA-Z0-9.!\#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        if (value.length > 0 && !emailRegex.test(value)) {
          $errorMsg.text('Not a valid email address').show();
        } else {
          $errorMsg.hide();
        }
      }

      $fields.on('keyup blur', function () {
        formatEmail.call(this);
      });
    }

    if (type === 'phone-number') {
      $fields.each(function() {
        const input = this;
        function formatPhoneAndValidate() {
          let x = input.value.replace(/\D/g, '');
          if (x.length === 11 && x.startsWith('1')) {
            x = x.slice(1);
          }
          x = x.slice(0, 10);
          let formatted = x;
          if (x.length > 6) {
            formatted = `(${x.slice(0,3)}) ${x.slice(3,6)}-${x.slice(6)}`;
          } else if (x.length > 3) {
            formatted = `(${x.slice(0,3)}) ${x.slice(3)}`;
          } else if (x.length > 0) {
            formatted = `(${x}`;
          }
          input.value = formatted;

          if (x.length > 0 && x.length < 10) {
            $errorMsg.text('Phone number must be 10 digits').show();
          } else {
            $errorMsg.hide();
          }
        }

        input.addEventListener('input', formatPhoneAndValidate);
        formatPhoneAndValidate();
      });
    }
  }

  validate_field('email-js', 'email-error-js', 'email');
  validate_field('phone-number-js', 'phone-number-error-js', 'phone-number');

  $('.fast-track-form .show-required-fields-btn').click(function() {
    const parent = $(this).closest('.fast-track-form');
    const requiredFields = parent.find('.ff-required');
    requiredFields.removeClass('ff-required-active');
    requiredFields.filter(function() {
      const inputs = $(this).find('input, textarea, select').filter(':enabled');
      if (!inputs.length) return false;

      return !inputs.toArray().some(function(input) {
        if (input.type === 'checkbox' || input.type === 'radio') return input.checked;
        return $(input).val();
      });
    }).addClass('ff-required-active');
  });
});
